import React from "react";
import { SmlLogo } from "../components/Logo";
import { DATA, Product } from "../constants/data";
import { ProductPage } from "../templates/Product";

const Home = () => {
  return (
    <>
      <SmlLogo />
      <ProductPage data={DATA[Product.BT60]} />
    </>
  );
};
export default Home;
